<!--
회원사 전체 지역(에이전트) 정보
-->
<template>
    <div class="uk-card uk-card-default uk-card-small simple-card" v-if="user">

        <div class="uk-card-header uk-flex uk-flex-between uk-flex-middle">
            <h4>
                <i class="material-icons">place</i>
                {{ user.nick }} >
                센터이용현황
            </h4>

            <div class="uk-width-expand">
                <a :href="'/region_members/' + userId"
                   class="uk-button uk-button-small uk-button-default"
                   style="margin-left: 1rem; font-size: 12px; padding: 0 10px; line-height: 26px"
                   target="_blank"
                >전체센터</a>
            </div>

            <!-- 회원 기본설정 -->
            <div class="font-bold mr-1rem">
                회원 기본설정
            </div>
            <table class="info-table small">
                <colgroup>
                    <col style="width: 9rem">
                    <col style="width: 9rem">
                    <col style="width: 9rem">
                    <col style="width: 9rem">
                    <col style="width: 6rem">
                </colgroup>
                <tbody>
                <tr>
                    <th scope="col" class="uk-text-center">
                        일반통관수수료
                    </th>
                    <td class="uk-text-center">

                        <span v-comma-number="user.customs_clearance_cost"></span>
                        <span class="font-size-0d875rem">원</span>
                    </td>
                    <th scope="col" class="uk-text-center">
                        사업자통관수수료
                    </th>
                    <td class="uk-text-center">
                        <span v-comma-number="user.customs_clearance_biz_cost"></span>
                        <span class="font-size-0d875rem">원</span>
                    </td>
                    <td class="uk-text-center">
                        <button
                            type="button"
                            class="uk-button uk-button-small uk-button-gray"

                            @click="$refs['update-user-cost'].form(user.id)"
                        >설정</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="uk-card-body">


            <!-- 각 센터 설정 -->
            <table class="info-table small uk-width-1-1 agent-center-table">
                <colgroup>
                    <col style="width: 12rem">
                    <col style="width: 100px">
                    <col style="width: 12rem">
                    <col style="width: 100px">
                    <col>
                    <col style="width: 7rem">
                    <col style="width: 10rem">
                    <col style="width: 7rem">
                    <col style="width: 7rem">
                    <col style="width: 7rem">

                    <col style="width: 9rem">
                    <col style="width: 9rem">
                    <col style="width: 7rem">

                    <col style="width: 6rem">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col" class="uk-text-left">
                        지역
                    </th>
                    <th scope="col" class="uk-text-center">
                        승인상태
                    </th>
                    <th scope="col" class="uk-text-center">
                        신청일시
                    </th>
                    <th scope="col" class="uk-text-center">
                        승인상세
                    </th>
                    <th scope="col">
                        운임가격표
                    </th>
                    <th scope="col" class="uk-text-center">
                        VAT과금
                    </th>
                    <th scope="col" class="uk-text-center">
                        합배송추가비 / 면제
                    </th>
                    <th scope="col" class="uk-text-center">
                        부피할인율
                    </th>
                    <th scope="col" class="uk-text-center">
                        델라웨어
                    </th>
                    <th scope="col" class="uk-text-center">
                        출고보류요청
                    </th>

                    <th scope="col" class="uk-text-center">
                        일반통관수수료
                    </th>
                    <th scope="col" class="uk-text-center">
                        사업자통관수수료
                    </th>
                    <th scope="col" class="uk-text-center">
                        구매수수료율
                    </th>

                    <th scope="col" class="uk-text-center">
                        수정
                    </th>

                </tr>
                </thead>

                <tbody>

                <tr
                    v-for="(agent, index) in agents"
                    :key="index"
                >

                    <td class="uk-text-left">
                        <img :src="get_region(agent.region_id).flag16"/>
                        {{ agent.name }}
                    </td>
                    <td class="uk-text-center">
                        <div v-if="agent.request_state_text">{{ agent.request_state_text }}</div>
                        <div v-if="! agent.request_state_text">
                            <a class="uk-link uk-link-reset uk-button uk-button-small uk-button-white"
                               :href="'/regions/' + agent.region_id + '/agents/' +  agent.id + '/users/' +  userId"
                               target="_blank"
                            >신청</a>
                        </div>

                    </td>
                    <td class="uk-text-center">
                        {{ agent.requested_at }}
                    </td>
                    <td class="uk-text-center">
                        <div v-if="agent.request_id" class="uk-flex uk-flex-column uk-flex-middle" style="gap: 0.25rem;">
                            <a class="uk-link uk-link-reset uk-button uk-button-small uk-button-black"
                               :href="'/regions/' + agent.region_id + '/agents/' + agent.id  + '/join-requests/' + agent.request_id"
                               target="_blank"
                            >승인상세</a>
                            <!-- TASK-066 (REF-020 결정 15 보완책 — 2026-05-04): 승인된 회원사의 센터 라우팅 진입 링크 추가. 총괄·창고·시스템관리자가 회원사 시점 작업 진입 -->
                            <!-- 안건 78 (2026-05-13): uk-link-reset 제거 — uk-button-primary 의 흰 글씨 무효화 해제. 파란 배경 + 검정 글씨 대비 결함 해소 (사용자 발견) -->
                            <a v-if="agent.applied"
                               class="uk-button uk-button-small uk-button-primary"
                               :href="'/regions/' + agent.region_id + '/agents/' + agent.id + '/users/' + userId"
                               target="_blank"
                               title="회원사 시점에서 본 센터의 화면 진입"
                            >회원사 진입</a>
                        </div>
                    </td>
                    <td class="uk-text-left">
                        {{ agent.shipping_cost_name }}
                    </td>

                    <!-- VAT 설정 -->
                    <td class="uk-text-center">
                        <div v-if="agent.applied">
                            {{ agent.applied.vat_charge_type_text }}
                            <div v-if="! agent.vat_charge_type" class="uk-text-muted">
                                지역설정
                            </div>
                        </div>
                    </td>

                    <!-- 합배송추가비 설정 -->
                    <td class="uk-text-center">
                        <div class="uk-flex uk-flex-top uk-flex-between" v-if="agent.applied">
                            <div class="ml-1">
                                <span class="font-size-0d875rem">{{ get_region(agent.region_id).currency_sign }}</span>
                                {{ agent.applied.over_amount_surcharge }}

                                <div v-if="! agent.over_amount_surcharge" class="uk-text-muted">
                                    지역설정
                                </div>
                            </div>
                            <div class="">

                                {{ agent.applied.surcharge_free_amount }} 개

                                <div v-if="! agent.surcharge_free_amount" class="uk-text-muted">
                                    지역설정
                                </div>
                            </div>
                        </div>
                    </td>


                    <!-- 부피할인율 설정 -->
                    <td class="uk-text-center">
                        <div v-if="agent.applied">
                            {{ agent.applied.volume_dc_rate }}%
                            <div v-if="! agent.volume_dc_rate" class="uk-text-muted">
                                기본설정
                            </div>
                        </div>
                    </td>


                    <!-- 델라웨어비용 설정 -->
                    <td class="uk-text-center">
                        <div v-if="agent.applied">
                            <span class="font-size-0d875rem">{{ get_region(agent.region_id).currency_sign }}</span>
                            {{ agent.applied.de_cost }}
                            <div v-if="! agent.de_cost" class="uk-text-muted">
                                지역설정
                            </div>
                        </div>
                    </td>

                    <!-- 출고보류요청 설정 -->
                    <td class="uk-text-center">
                        <div v-if="agent.applied">
                            <div :class="agent.shipout_hold_req_type === 1 ? null : 'uk-text-muted'">
                                {{ agent.applied.shipout_hold_req_type_text }}
                            </div>
                        </div>
                    </td>

                    <!-- 일반통관수수료 설정 -->
                    <td class="uk-text-center">
                        <div v-if="agent.applied">
                            <span v-comma-number="agent.applied.customs_clearance_cost"></span>
                            <span class="font-size-0d875rem">원</span>

                            <div v-if="agent.customs_clearance_cost === null" class="uk-text-muted">
                                회원 기본설정
                            </div>
                        </div>
                    </td>

                    <!-- 사업자통관수수료 설정 -->
                    <td class="uk-text-center">
                        <div v-if="agent.applied">
                            <span v-comma-number="agent.applied.customs_clearance_biz_cost"></span>
                            <span class="font-size-0d875rem">원</span>

                            <div v-if="agent.customs_clearance_biz_cost === null" class="uk-text-muted">
                                회원 기본설정
                            </div>
                        </div>
                    </td>

                    <!-- 구매수수료율 설정 (TASK-176) -->
                    <td class="uk-text-center">
                        <div v-if="agent.applied">
                            <span v-if="agent.applied.buy_fee_rate_pct !== null && agent.applied.buy_fee_rate_pct !== undefined">{{ agent.applied.buy_fee_rate_pct }}%</span>
                            <span v-else class="uk-text-muted">미설정</span>
                        </div>
                    </td>

                    <!-- 설정 -->
                    <td class="uk-text-center">
                        <button
                            type="button"
                            class="uk-button uk-button-small uk-button-gray"

                            v-if="agent.applied"

                            @click="$refs['update-user-role-cost'].form(user.id, agent.id)"
                        >설정</button>
                    </td>

                </tr>

                </tbody>
            </table>

        </div>

        <!-- 컴포넌트 -->
        <update-user-cost ref="update-user-cost" :csrf-token="csrfToken"></update-user-cost>
        <update-user-role-cost ref="update-user-role-cost" :csrf-token="csrfToken"></update-user-role-cost>
    </div>

</template>

<script>
import regionAble from "../common/region-able.vue";

export default {
    mixins: [
        regionAble,
    ],
    components: {
        'update-user-cost': require('../user/update-user-cost.vue').default,
        'update-user-role-cost': require('../user/update-user-role-cost.vue').default,
    },
    props: {
        /**
         * csrf token
         */
        csrfToken: {
            type: String,
            required: true,
        },

        /**
         * 회원사ID
         */
        userId: {
            type: Number,
            required: true,
        },
    },
    data: function () {
        return {
            // (object) 회원사 정보
            user: null,

            // (array) 에이전트 배열
            agents: [],
        };
    },
    computed: {},
    mounted() {
        this.init(this.userId);
    },
    methods: {
        // 초기 로드
        init(user_id) {

            // promise 생성
            let load = new Promise((resolve, reject) => {
                //reject('failed !');

                // ajax 옵션
                let opts = {
                    type: 'get',
                    url: '/users/' + user_id + '/agent-info',
                    contentType: 'application/json',
                    data: {},
                    success: (response, textStatus, jqXHR) => {
                        // promise 성공
                        resolve(response);
                    },
                };

                // ajax 실행
                $.app.ajax.module.background(opts);
            });


            // promise 처리
            load.then((response) => {
                this.user = response.user;
                this.agents = response.agents;
            });
        },
    },
}
</script>

<style lang="scss" scoped>
// 센터이용현황 표 한정 — 마우스 오버 행 강조
.agent-center-table tbody tr:hover > td {
    background-color: #eef5fd;
}
</style>